export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 5;
export const RES_PER_PAGE = 10;
export const KEY = 'f57f89f3-d291-46e9-9c52-ec19251ec3d3';
